<div class="h-full flex items-center gap-4 xl:gap-8 font-header font-(--font-weight-header)">
  <app-search-input class="w-3xs" placeholder="Search..." [value]="filteringService.search()" />

  <!-- New homes color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
  <app-toggle
    [(checked)]="filteringService.includeNewHomes"
    ariaLabel="Show new homes"
    class="px-3 py-2 h-10 text-sm rounded-md transition-all duration-100 hover:bg-white/10 hover:ring-1 hover:ring-inset hover:ring-white/20"
    colorClass="has-checked:bg-villages-green-50 outline-white/30"
    darkColorClass="dark:has-checked:bg-villages-green-500 dark:outline-white/30"
  >
    <span class="text-gray-100"> New </span>
  </app-toggle>

  <!-- Preowned homes color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
  <app-toggle
    [(checked)]="filteringService.includePreownedHomes"
    ariaLabel="Show preowned homes"
    class="px-3 py-2 h-10 text-sm rounded-md transition-all duration-100 hover:bg-white/10 hover:ring-1 hover:ring-inset hover:ring-white/20"
    colorClass="has-checked:bg-villages-red-500 outline-white/30"
    darkColorClass="dark:has-checked:bg-villages-red-500 dark:outline-white/30"
  >
    <span class="text-gray-100"> Preowned </span>
  </app-toggle>

  <!-- Homesites homes color is also hard-coded in the src/app/components/map/utils/listingColor.ts file -->
  <app-toggle
    [(checked)]="filteringService.includeHomesites"
    ariaLabel="Show homesites"
    class="px-3 py-2 h-10 text-sm rounded-md transition-all duration-100 hover:bg-white/10 hover:ring-1 hover:ring-inset hover:ring-white/20"
    colorClass="has-checked:bg-villages-gold-500 outline-white/30"
    darkColorClass="dark:has-checked:bg-villages-gold-500 dark:outline-white/30"
  >
    <span class="text-gray-100"> Homesites </span>
  </app-toggle>

  <div class="relative">
    <button
      type="button"
      (click)="toggleFilters()"
      class="rounded-md px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 whitespace-nowrap cursor-pointer transition-all duration-100 hover:bg-white/10 hover:ring-1 hover:ring-inset hover:ring-white/20 active:bg-white active:text-primary-700 active:ring-primary-200/60 active:shadow-inner focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40 aria-pressed:bg-white/10 aria-pressed:ring-1 aria-pressed:ring-inset aria-pressed:ring-white/20 hover:aria-pressed:bg-white/20"
      [attr.aria-pressed]="filtersOpen()"
      [attr.aria-expanded]="filtersOpen()"
      aria-haspopup="true"
    >
      <svg
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="currentColor"
        aria-hidden="true"
      >
        <path
          d="M440-120v-240h80v80h320v80H520v80h-80Zm-320-80v-80h240v80H120Zm160-160v-80H120v-80h160v-80h80v240h-80Zm160-80v-80h400v80H440Zm160-160v-240h80v80h160v80H680v80h-80Zm-480-80v-80h400v80H120Z"
        />
      </svg>

      <span class="hidden min-[1200px]:inline">Filters</span>

      <span
        class="size-2 rounded-full bg-villages-gold-500 shrink-0 transition-opacity"
        [class.opacity-0]="!filteringService.hasFilters()"
        [attr.aria-label]="filteringService.hasFilters() ? 'Filters active' : null"
        aria-hidden="true"
      ></span>
    </button>

    @if (filtersOpen()) {
      <div class="fixed inset-0 z-52" (click)="filtersOpen.set(false)" aria-hidden="true"></div>

      <div
        class="absolute left-1/2 -translate-x-1/2 top-full mt-2 w-lg max-h-[calc(100vh-10rem)] flex flex-col rounded-lg bg-white dark:bg-gray-800 shadow-xl ring-1 ring-black/5 dark:ring-white/10 z-53 overflow-hidden"
        role="dialog"
        aria-modal="false"
        aria-label="Property Filters"
      >
        <div class="px-4 py-3 border-b border-gray-200 dark:border-gray-700 shrink-0">
          <h2 class="text-base font-semibold text-gray-900 dark:text-white">Property Filters</h2>
        </div>

        <div class="overflow-y-auto flex-1 p-4">
          <app-filters />
        </div>

        <div
          class="flex gap-3 px-4 py-3 bg-white dark:bg-gray-800 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] dark:shadow-[0_-4px_12px_rgba(0,0,0,0.3)] shrink-0"
        >
          <button
            type="button"
            class="flex-1 rounded-lg border border-primary-500 dark:border-primary-400 px-4 py-2.5 text-sm font-medium text-primary-500 dark:text-primary-400 hover:bg-primary-500 hover:text-white dark:hover:bg-primary-400 dark:hover:text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 cursor-pointer transition-colors"
            (click)="filteringService.resetFilters()"
          >
            Clear Filters
          </button>
          <button
            type="button"
            class="flex-1 rounded-lg bg-primary-500 hover:bg-primary-400 px-4 py-2.5 text-sm font-medium text-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 cursor-pointer transition-colors"
            (click)="filtersOpen.set(false)"
          >
            Apply Filters
          </button>
        </div>
      </div>
    }
  </div>

  <button
    type="button"
    (click)="modelGalleryClicked.emit()"
    class="rounded-md px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 whitespace-nowrap cursor-pointer transition-all duration-100 hover:bg-white/10 hover:ring-1 hover:ring-inset hover:ring-white/20 active:bg-white active:text-primary-700 active:ring-primary-200/60 active:shadow-inner focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40"
  >
    <svg height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor">
      <path
        d="M80-160v-400l240-240 240 240v400H80Zm80-80h120v-120h80v120h120v-287L320-687 160-527v287Zm120-200v-80h80v80h-80Zm360 280v-433L433-800h113l174 174v466h-80Zm160 0v-499L659-800h113l108 108v532h-80Zm-640-80h320-320Z"
      />
    </svg>

    <span class="hidden min-[1200px]:inline">Model Gallery</span>
  </button>

  <div class="ml-auto relative">
    <button
      type="button"
      (click)="toggleSaveSearch()"
      class="px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 whitespace-nowrap cursor-pointer transition-all duration-100 rounded-md hover:bg-white/10 hover:ring-1 hover:ring-inset hover:ring-white/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40"
      [attr.aria-expanded]="saveSearchOpen()"
      aria-haspopup="true"
    >
      <svg class="h-5 w-5 shrink-0" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
        <path
          d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Zm80-122 200-86 200 86v-518H280v518Zm0-518h400-400Z"
        />
      </svg>
      <span class="hidden min-[1500px]:inline">Save Search</span>
    </button>

    @if (saveSearchOpen()) {
      <div class="fixed inset-0 z-52" (click)="saveSearchOpen.set(false)" aria-hidden="true"></div>
      <div
        class="absolute left-1/2 -translate-x-1/2 top-full mt-1 w-80 rounded-lg bg-white dark:bg-gray-800 shadow-lg ring-1 ring-black/5 dark:ring-white/10 px-4 pt-3 pb-3 z-53"
      >
        <app-filters-saved class="flex flex-col gap-2" />
      </div>
    }
  </div>

  <button
    type="button"
    class="group px-3 py-2 text-sm text-gray-100 h-10 items-center flex flex-row gap-2 cursor-pointer transition-all duration-100 rounded-md hover:bg-white/10 hover:ring-1 hover:ring-inset hover:ring-white/20 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white/40 aria-pressed:bg-white/10 aria-pressed:ring-1 aria-pressed:ring-inset aria-pressed:ring-white/20"
    [attr.aria-label]="filteringService.dreamHomes() ? 'Dream Homes active' : 'Show Dream Homes'"
    [attr.aria-pressed]="filteringService.dreamHomes()"
    (click)="toggleDreamHomes()"
  >
    <svg
      viewBox="0 -960 960 960"
      class="h-5 w-5 transition-colors fill-white group-aria-pressed:fill-red-500"
      aria-hidden="true"
    >
      <path
        d="m480-147.69-44.15-40.39Q336-278.23 264.31-349.35q-71.7-71.11-114.96-126.19-43.27-55.07-56.31-99.96Q80-620.38 80-665.23q0-92 61.5-153.38Q203-880 295.38-880q55 0 102.31 26.5Q445-827 480-778.46 515-827 562.31-853.5q47.31-26.5 102.31-26.5 91.84 0 153.61 61.39Q880-757.22 880-665.23q0 44.85-13.04 89.73-13.04 44.89-56.31 99.96-43.26 55.08-114.76 126.19-71.5 71.12-171.36 161.27L480-147.69Z"
      />
    </svg>

    <span class="hidden min-[1500px]:inline whitespace-nowrap">My Dream Homes</span>

    @if (listingsService.savedListingsAvailableCount()) {
      <span
        class="inline-flex items-center rounded-full bg-primary-300 px-2 py-1 text-xs font-medium text-white inset-ring inset-ring-gray-500/10"
      >
        {{ listingsService.savedListingsAvailableCount() }}
      </span>
    }
  </button>
  <!-- } -->
</div>
